class Banco{
    constructor(
        Nombre,
        Formato,
        Logo,
        ListaTarjetas
    ){
        this.Nombre=Nombre;
        this.Formato=Formato;
        this.Logo=Logo;
        this.ListaTarjetas=ListaTarjetas;
    }
}

export default Banco